import React from "react";

interface AdminTopNavProps {
  searchQuery?: string;
  onSearchChange?: (val: string) => void;
  searchPlaceholder?: string;
}

export const AdminTopNav: React.FC<AdminTopNavProps> = ({
  searchQuery,
  onSearchChange,
  searchPlaceholder = "Search...",
}) => {
  return (
    <header className="bg-white border-b border-gray-200 h-16 px-8 flex items-center justify-between flex-shrink-0 z-10">
      {/* Horizontal Navigation tabs */}
     <div />

      {/* Right Header Panel (Search, Export, Actions) */}
      <div className="flex items-center gap-4">
        {/* Search Input (conditionally rendered) */}
        {onSearchChange !== undefined && (
          <div className="relative">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </span>
            <input
              type="text"
              value={searchQuery ?? ""}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              className="pl-9 pr-4 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:bg-white transition-all w-60"
            />
          </div>
        )}

        {/* Avatar Profile */}
        <div className="h-8 px-4 rounded-full uppercase bg-orange-100 border border-orange-200 flex items-center justify-center text-xs font-bold text-[#E27D00] shadow-sm select-none cursor-pointer">
          {sessionStorage.getItem("adminEnvironment")}
        </div>
      </div>
    </header>
  );
};
